import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { ProposalEntity } from 'v2/models';
import '../../styles/main.scss';
import ProposalResponseTokenMessage from './ProposalResponseTokenMessage';
import ProposalTokenChat from './ProposalTokenChat';

export type ProposalStatus =
  | 'provider-response-rejected'
  | 'provider-response-accepted'
  | 'buyer-response-rejected'
  | 'buyer-response-accepted'
  | '';

interface Params {
  tokenId: string;
  userId: string;
}

interface StatusContainerProps {
  proposalStatus?: ProposalStatus;
  proposal: ProposalEntity;
  isLoading: boolean;
}

export const PROPOSAL_RESPONSES = {
  'provider-response-rejected': 'We appreciate your response.',
  'provider-response-accepted':
    'Your response has been submitted. You will be notified when the buyer gets back to you.',
  'buyer-response-rejected': 'Sorry you were not selected.',
  'buyer-response-accepted':
    'The buyer has accepted your response and is in conversation with a member of your team.',
};

const StatusContainer = ({
  proposalStatus,
  proposal,
  isLoading,
}: StatusContainerProps) => {
  const { params } = useRouteMatch<Params>();
  const tokenId = params.tokenId;
  const userId = params.userId;

  if (!proposalStatus || isLoading) {
    return null;
  }

  const showChat =
    proposalStatus === 'buyer-response-accepted' &&
    proposal.data_provider_response?.submitted_by?.id === parseInt(userId);

  return (
    <>
      {!showChat ? (
        <ProposalResponseTokenMessage
          text={PROPOSAL_RESPONSES[proposalStatus]}
          title={
            proposalStatus !== 'buyer-response-rejected' ? 'Thank you!' : ''
          }
        />
      ) : (
        <ProposalTokenChat
          userId={Number(userId)}
          proposal={proposal}
          token={tokenId}
        />
      )}
    </>
  );
};

export default StatusContainer;
